export const SET_HOLD_ORDERS_COUNT = "SET_HOLD_ORDERS_COUNT";
export const INCREMENT_HOLD_ORDERS_COUNT = "INCREMENT_HOLD_ORDERS_COUNT";
export const DECREMENT_HOLD_ORDERS_COUNT = "DECREMENT_HOLD_ORDERS_COUNT";

export const setHoldOrdersCount = (count) => ({
  type: SET_HOLD_ORDERS_COUNT,
  payload: count,
});

export const incrementHoldOrdersCount = () => ({
  type: INCREMENT_HOLD_ORDERS_COUNT,
});

export const decrementHoldOrdersCount = () => ({
  type: DECREMENT_HOLD_ORDERS_COUNT,
});
